import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
const styles = theme => ({
  root: {
    width: "100%",
    height: "100%",
    paddingTop: 20
  },
  swipe: {
    width: "100%",
    height: "calc(100% - 48px)",
    "& > .react-swipeable-view-container": {
      height: "100%"
    }
  },
  tab: {
    "& span": {
      fontSize: 12
    }
  }
});
class DefiTabs extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      value: this.props.defaultTab
    };
    this.handleChange = (event, value) => {
      this.setState({
        value
      });
    };
    this.handleChangeIndex = index => {
      this.setState({
        value: index
      });
    };
    this.createLabel = (tab, i) => {
      if (tab.activeTitle) {
        if (this.state.value === i) {
          return tab.activeTitle;
        }
      }
      return tab.title;
    };
  }
  render() {
    const _this$props = this.props,
      classes = _this$props.classes,
      children = _this$props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement(AppBar, {
      position: "static",
      color: "default"
    }, /*#__PURE__*/React.createElement(Tabs, {
      value: this.state.value,
      onChange: this.handleChange,
      indicatorColor: "primary",
      textColor: "primary",
      variant: "fullWidth"
    }, children.map((tab, i) => {
      return /*#__PURE__*/React.createElement(Tab, {
        className: classes.tab,
        label: this.createLabel(tab.props, i),
        key: i
      });
    }))), /*#__PURE__*/React.createElement(SwipeableViews, {
      axis: "x",
      index: this.state.value,
      onChangeIndex: this.handleChangeIndex,
      className: classes.swipe
    }, children.map(tab => tab)));
  }
}
export default withStyles(styles)(DefiTabs);